module.exports = "/images/gotham-6.jpg";